export const SUPPORT_EMAIL = "info@hiyahealthcare.com";
